<template>
  <div class="app-container">
    <!-- 搜索筛选区域 -->
    <div class="filter-container">
      <el-form inline size="small">
        <el-form-item label="关键词">
          <el-input
            v-model="listQuery.keyword"
            placeholder="CRS订单号/分销商订单号/状态"
            clearable
            style="width: 200px"
          />
        </el-form-item>
        <el-form-item label="分销商订单号">
          <el-input
            v-model="listQuery.distributor_res_id"
            placeholder="精确查询"
            clearable
            style="width: 150px"
          />
        </el-form-item>
        <el-form-item label="CRS订单号">
          <el-input
            v-model="listQuery.crs_order_no"
            placeholder="精确查询"
            clearable
            style="width: 150px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="订单状态">
          <el-input
            v-model="listQuery.crs_order_status"
            placeholder="精确查询"
            clearable
            style="width: 100px"
          />
        </el-form-item>
        <el-form-item label="更新时间">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 360px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      stripe
      size="small"
    >
      <el-table-column label="ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="API账号ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.api_account_id }}
        </template>
      </el-table-column>

      <el-table-column label="CRS订单号" min-width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.crs_order_no }}
        </template>
      </el-table-column>

      <el-table-column label="分销商订单号" min-width="180" align="center">
        <template slot-scope="scope">
          {{ scope.row.distributor_res_id }}
        </template>
      </el-table-column>

      <el-table-column label="订单状态" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.crs_order_status === 'N'" type="info" size="mini">待确认</el-tag>
          <el-tag v-else-if="scope.row.crs_order_status === 'A'" type="success" size="mini">已确认</el-tag>
          <el-tag v-else-if="scope.row.crs_order_status === 'NS'" type="warning" size="mini">未到</el-tag>
          <el-tag v-else-if="scope.row.crs_order_status === 'C'" type="primary" size="mini">已入住</el-tag>
          <el-tag v-else-if="scope.row.crs_order_status === 'F'" type="success" size="mini">已离店</el-tag>
          <el-tag v-else-if="scope.row.crs_order_status === 'E'" type="danger" size="mini">已取消</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="更新时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.updated_at }}
        </template>
      </el-table-column>

      <el-table-column label="其他" min-width="80" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.raw_request || scope.row.raw_response">...</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column label="操作" width="120" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleViewDetail(scope.row)"
          >
            查看详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 查看详情弹窗 -->
    <el-dialog
      title="订单取消记录详情"
      :visible.sync="dialogDetailVisible"
      width="700px"
      :close-on-click-modal="true"
    >
      <div class="detail-content">
        <el-descriptions :column="1" border size="small">
          <el-descriptions-item label="API账号ID">
            {{ currentRow.api_account_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="CRS订单号">
            {{ currentRow.crs_order_no || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="分销商订单号">
            {{ currentRow.distributor_res_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="订单状态">
            <el-tag v-if="currentRow.crs_order_status === 'N'" type="info" size="mini">待确认</el-tag>
            <el-tag v-else-if="currentRow.crs_order_status === 'A'" type="success" size="mini">已确认</el-tag>
            <el-tag v-else-if="currentRow.crs_order_status === 'NS'" type="warning" size="mini">未到</el-tag>
            <el-tag v-else-if="currentRow.crs_order_status === 'C'" type="primary" size="mini">已入住</el-tag>
            <el-tag v-else-if="currentRow.crs_order_status === 'F'" type="success" size="mini">已离店</el-tag>
            <el-tag v-else-if="currentRow.crs_order_status === 'E'" type="danger" size="mini">已取消</el-tag>
            <span v-else>无</span>
          </el-descriptions-item>
          <el-descriptions-item label="创建时间">
            {{ currentRow.created_at || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="更新时间">
            {{ currentRow.updated_at || '无' }}
          </el-descriptions-item>
        </el-descriptions>

        <div class="json-section">
          <div class="json-label">原始请求JSON：</div>
          <div v-if="currentRow.raw_request" class="json-content">
            <pre>{{ formatJson(currentRow.raw_request) }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>

        <div class="json-section">
          <div class="json-label">原始响应JSON：</div>
          <div v-if="currentRow.raw_response" class="json-content">
            <pre>{{ formatJson(currentRow.raw_response) }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDetailVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      // 搜索参数
      listQuery: {
        page: 1,
        limit: 10,
        keyword: undefined,
        start_at: undefined,
        end_at: undefined,
        distributor_res_id: undefined,
        crs_order_no: undefined,
        crs_order_status: undefined,
        sort: 'id',
        order: 'DESC',
      },
      // 日期范围
      dateRange: null,
      // 查看详情弹窗
      dialogDetailVisible: false,
      currentRow: {},
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 格式化JSON字符串
    formatJson(jsonStr) {
      if (!jsonStr) return ''
      try {
        const parsed = JSON.parse(jsonStr)
        return JSON.stringify(parsed, null, 2)
      } catch (e) {
        return jsonStr
      }
    },
    // 获取列表数据
    getList() {
      this.listLoading = true

      // 处理日期范围
      if (this.dateRange && this.dateRange.length === 2) {
        this.listQuery.start_at = this.dateRange[0]
        this.listQuery.end_at = this.dateRange[1]
      } else {
        this.listQuery.start_at = undefined
        this.listQuery.end_at = undefined
      }

      // 处理空值参数
      const params = {}
      Object.keys(this.listQuery).forEach((key) => {
        const val = this.listQuery[key]
        if (val !== '' && val !== undefined && val !== null) {
          params[key] = val
        }
      })

      request({
        url: '/api/backend/liCheng/order/cancelList',
        method: 'get',
        params: params,
      })
        .then((response) => {
          this.list = response.data.items
          this.total = response.data.total
          this.listLoading = false
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    // 点击查询按钮
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    // 点击重置按钮
    handleReset() {
      this.listQuery = {
        page: 1,
        limit: 10,
        keyword: undefined,
        start_at: undefined,
        end_at: undefined,
        distributor_res_id: undefined,
        crs_order_no: undefined,
        crs_order_status: undefined,
        sort: 'id',
        order: 'DESC',
      }
      this.dateRange = null
      this.getList()
    },
    // 每页显示数量变化
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    // 当前页码变化
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    // 查看详情
    handleViewDetail(row) {
      this.currentRow = Object.assign({}, row)
      this.dialogDetailVisible = true
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.filter-container {
  margin-bottom: 10px;
}
.pagination-container {
  margin-top: 20px;
}
.detail-content {
  max-height: 500px;
  overflow: auto;
}
.json-section {
  margin-top: 15px;
  .json-label {
    font-weight: bold;
    margin-bottom: 8px;
  }
  .json-content {
    background-color: #f5f7fa;
    padding: 15px;
    border-radius: 4px;
    max-height: 150px;
    overflow: auto;
    pre {
      margin: 0;
      white-space: pre-wrap;
      word-wrap: break-word;
      font-size: 12px;
      line-height: 1.5;
      color: #333;
    }
  }
  .json-empty {
    text-align: center;
    padding: 15px;
    color: #999;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
}
</style>
